module.exports = __webpack_public_path__ + "img/editing_2.ca87c458.png";